<template>
  <div class="section__response">
    <table class="responses__table">
      <thead>
        <tr class="responses__header">
          <td class="col__header res__code">Code</td>
          <td class="col__header res__description">Description</td>
          <td class="col__header res__link">Links</td>
        </tr>
      </thead>
      <!-- tbody loop -->
      <tbody v-for="key of Object.keys(responsesParse)">
        <tr class="response">
          <td class="res__key">{{ key }}</td>
          <td class="res__description">
            <div class="res__description__inner">
              <p v-html="converted(responsesParse[key].description)"></p>
            </div>
            <template v-if="responsesParse[key]['content']">
              <section class="res__control">
                <div class="res__mediaType">
                  <small>Media Type</small>
                  <select class="content__type">
                    <option :value="responseType(key)">
                      {{ responseType(key) }}
                    </option>
                  </select>
                  <small v-if="key === '200'" class="res__accept">
                    Controls Accept header
                  </small>
                </div>
                <div
                  v-if="key === 'default' && exampleCheck(key)"
                  class="res__examples"
                >
                  <small>Examples</small>
                  <select class="examples__type" @change="getIndex($event)">
                    <option v-for="exKey in exampleKeys(key)" :value="exKey">
                      {{ exKey }}
                    </option>
                  </select>
                  <div class="model__example"></div>
                </div>
              </section>
              <div class="model__example">
                <ul class="tab">
                  <li class="tab__item">
                    <a
                      v-if="key === '200'"
                      class="tab__links"
                      :class="[clickResult ? 'clicked' : '']"
                      @click.prevent="selectExampleValue($event)"
                      >Example values</a
                    >
                    <span v-else style="font-weight: bold">Example values</span>
                  </li>
                  <li class="tab__item" v-if="key === '200'">
                    <a
                      class="tab__links"
                      :class="[clickResult ? '' : 'clicked']"
                      @click.prevent="selectSchema($event)"
                      >Schema</a
                    >
                  </li>
                </ul>
                <div class="model__box">
                  <div v-if="key === '200' && clickResult">
                    <pre>{{ successExamplePrint(key) }}</pre>
                  </div>
                  <div v-else>
                    <pre v-if="key === '200'" class="schemaPre">{{
                      successSchemaPrint(key)
                    }}</pre>
                    <div v-else>
                      <pre>{{ defaultExamplePrint(key).value }}</pre>
<!--                      <div v-if="responseTags !== 'Webhook'" class="pre__ex__des">-->
                        <p style="font-weight: bold">Example Description</p>
                        <p>{{ defaultExamplePrint(key).description }}</p>
<!--                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import { maxDepth, recursiveParser } from "../data/userData";

import responses from "../data/document/openapi/responses.yaml";
import responseAuthError from "../data/document/responses/response.error.yaml";
import responseError from "../data/document/openapi/response.error.yaml";
import webhookSchemas from "../data/document/schemas/webhook.yaml";
import sso from "../data/document/path/sso.yaml"

export default {
  name: "Response",
  props: {
    data: Object,
    responses: Object,
  },
  data: function () {
    return {
      clickResult: true,
      index: 0,
    };
  },
  methods: {
    converted(description) {
      const md = new MarkdownIt();
      let converted = md.render(description);
      converted = converted.replaceAll("&lt;br&gt;", "<br>");
      return converted;
    },
    selectExampleValue(event) {
      this.clickResult = true;
    },
    selectSchema(event) {
      this.clickResult = false;
    },
    responseType(key) {
      return Object.keys(this.responsesParse[key].content)[0];
    },
    exampleCheck(key) {
      return (
        "examples" in this.responsesParse[key].content[this.responseType(key)]
      );
    },
    exampleKeys(key) {
      return Object.keys(
        this.responsesParse[key].content[this.responseType(key)].examples
      );
    },
    successExamplePrint(key) {
      const properties =
        this.responsesParse[key].content[this.responseType(key)].schema
          .properties;

      const result = {};
      // permission list example
      if (!properties) {
        const permission =
          this.responsesParse[key].content[this.responseType(key)].schema
            .example;
        Object.keys(permission).forEach((property) => {
          Object.assign(result, { [property]: permission[property] });
        });
      }
      properties &&
        Object.keys(properties).forEach((property) => {
          // folder list example
          if (property === "lists" && !properties[property]?.example) {
            Object.assign(result, {
              [property]: properties[property].items.example,
            });
          } else {
            let data = properties[property].example;
            if (!data) {
              if (properties[property].type === 'string') {
                data = '';
              } else {
                data = {};
              }
              if (properties[property].properties) {
                Object.keys(properties[property].properties).forEach((prop) => {
                  Object.assign(data, {
                    [prop]: properties[property].properties[prop].example,
                  });
                });
              }
            }
            Object.assign(result, {
              [property]: data,
            });
          }
        });
      return result;
    },
    successSchemaPrint(key) {
      console.log(this.responsesParse[key])
      const properties =
        this.responsesParse[key].content[this.responseType(key)].schema
          .properties;

      // permission list example
      if (!properties) {
        return this.responsesParse[key].content[this.responseType(key)].schema;
      }
      return properties && properties;
    },
    getIndex(e) {
      this.index = e.target.selectedIndex;
    },
    defaultExamplePrint(key) {
      // if (this.responseTags !== "Webhook") {
        const examples =
          this.responsesParse[key].content[this.responseType(key)].examples;
        const exampleValue = this.exampleKeys(key)[this.index];
        return examples[exampleValue];
      // } else {
      //   const properties =
      //     this.responsesParse[key].content[this.responseType(key)].schema
      //       .properties;
      //   const result = {};
      //   Object.keys(properties).forEach((property) => {
      //     if (property === "success") {
      //       Object.assign(result, {
      //         [property]: true,
      //       });
      //     } else if (property === "all") {
      //       Object.assign(result, {
      //         [property]: properties[property].type,
      //       });
      //     } else {
      //       const datas = properties[property].items || properties[property];
      //       let data = {};
      //       datas.allOf.forEach((item) => {
      //         Object.assign(data, item.properties);
      //       });
      //       Object.assign(result, {
      //         data: data,
      //       });
      //     }
      //   });
      //   const webhookResult = {};
      //   webhookResult.value = result;
      //
      //   return properties && webhookResult;
      // }
    },
  },
  computed: {
    responsesParse() {
      if (!this.responses) return;
      const depth = maxDepth(this.responses);
      let document;
      this.index = 0;

      // if (this.responseTags === "Webhook") {
      //   Object.keys(this.responses).forEach((key) => {
      //     document = webhookSchemas;
      //     this.responses[key] = recursiveParser(
      //       this.responses[key],
      //       depth,
      //       document
      //     );
      //   });
      //   return this.responses;
      // }

      Object.keys(this.responses).forEach((key) => {
        if (key === "200") {
          document = responses;
          this.responses[key] = recursiveParser(
            this.responses[key],
            depth,
            document
          );

        } else if (key === "default" && this.responseTags === "Auth") {
          document = responseAuthError;
          this.responses[key] = recursiveParser(
            this.responses[key],
            depth,
            document
          );
        } else {
          document = responseError;
          this.responses[key] = recursiveParser(
            this.responses[key],
            depth,
            document
          );
        }
      });
      return this.responses;
    },
    responseTags() {
      return this.data && this.data.tags[0];
    },
  },
};
</script>

<style scoped lang="scss">
table thead tr th {
  font-size: 12px;
  font-weight: 700;
  padding: 12px 0;
  text-align: left;
  border-bottom: 1px solid rgba(59, 65, 81, 0.2);
  font-family: sans-serif;
  color: #3b4151;
}

td {
  vertical-align: top;
  min-width: 15em;
  padding: 10px 0;
}

select {
  min-width: 230px;
  font-size: 14px;
  font-weight: 700;
  padding: 5px 40px 5px 10px;
  border: 2px solid #41444e;
  border-radius: 4px;
  background: #f7f7f7;
  background-size: 20px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 25%);
  font-family: sans-serif;
  color: #3b4151;
}

ul {
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 40px;
}

pre {
  padding: 10px;
  display: block;
  color: white;
  font-family: monospace;
  font-weight: 600;
  background: rgba(51, 51, 51, 100);
  border-radius: 3px;
  width: 99%;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  word-break: break-all;
  white-space: pre-wrap;
}

pre.schemaPre {
  background: #d0ddd8;
  color: black;
  width: 99%;
}

.col__header {
  border-bottom: 1px solid rgba(59, 65, 81, 0.2);
  font-weight: 700;
  font-size: 12px;
  color: #3b4151;
  font-family: sans-serif;
  padding: 12px 0;
}

.res__code {
  font-weight: 700;
  margin-right: 0.75em;
  font-family: sans-serif;
  color: #3b4151;
}

.res__description {
  width: 99%;
  margin-bottom: 2em;
}

.res__control {
  padding-top: 1em;
  display: flex;

  .res__mediaType {
    display: block;
    margin-bottom: 0.2em;
    font-size: 0.7em;

    .content__type {
      display: block;
      margin-right: 1em;
    }

    .res__accept {
      color: green;
      display: block;
      margin-bottom: 0.2em;
    }
  }

  .res__examples {
    display: block;
    margin-bottom: 0.2em;
    font-size: 0.7em;

    .examples__type {
      display: block;
    }
  }
}

.tab {
  display: flex;
  padding: 0;
  list-style: none;

  li:first-of-type {
    position: relative;
    padding-left: 0;
    padding-right: 12px;
  }

  li:first-of-type:after {
    position: absolute;
    top: 0;
    right: 6px;
    width: 1px;
    height: 100%;
    content: "";
    background: rgba(0, 0, 0, 0.2);
  }
}

li {
  font-size: 12px;
  min-width: 60px;
  cursor: pointer;
  font-family: sans-serif;
  color: #3b4151;
}

.clicked {
  font-weight: bold;
}

div::v-deep p > code {
  border-radius: 2px;
  background-color: rgba(51, 51, 51, 0.05);
  color: rgba(51, 51, 51, 0.9);
  padding: 0px 5px;
  border: 1px solid rgba(51, 51, 51, 0.1);
  font-family: Courier, monospace;
}
</style>
